import apiClient from "./apiClient";

/* ── In-memory GET cache with 5-minute TTL ─────────────────────────────── */
const _cache = {};

const dedupGet = (key, fetchFn, ttl = 300000) => {
  const now = Date.now();
  if (_cache[key] && now - _cache[key].ts < ttl) return _cache[key].promise;
  const promise = fetchFn();
  _cache[key] = { promise, ts: now };
  promise.catch(() => { delete _cache[key]; });
  return promise;
};

export const clearEmployeeCache = () => {
  for (const k in _cache) delete _cache[k];
};

/* =====================================================
   EMPLOYEE PROFILE
   GET /employees/api/employee/profile/
===================================================== */
export const getEmployeeProfile = () =>
  dedupGet("employee_profile", () =>
    apiClient.get("/employees/api/employee/profile/")
  );


/* =====================================================
   EMPLOYEE ACTIVITIES API
===================================================== */

/**
 * Create activity
 */
export const createEmployeeActivity = (data) => {
  return apiClient.post("/employees/api/employee-activities/", data).finally(() => {
    clearEmployeeCache();
  });
};

/**
 * Employee progress
 */
export const getEmployeeProgress = (params = {}) =>
  dedupGet(`emp_progress_${JSON.stringify(params)}`, () =>
    apiClient.get("/employees/api/employee-activities/employee_progress/", { params })
  );


/* =====================================================
   EMPLOYEE WORK ASSIGNMENTS (NEW)
   ===================================================== */
export const getEmployeeWorkAssignments = (params = {}) =>
  dedupGet(`emp_work_assign_${JSON.stringify(params)}`, () =>
    apiClient.get("/employees/api/employee-work-assignments/", { params })
  );

export const createEmployeeWorkAssignment = (data) => {
  return apiClient.post("/employees/api/employee-work-assignments/", data).finally(() => {
    clearEmployeeCache();
  });
};

export const updateEmployeeWorkAssignment = (assignmentId, data, params = {}) => {
  return apiClient.patch(
    `/employees/api/employee-work-assignments/${assignmentId}/`,
    data,
    { params }
  ).finally(() => {
    clearEmployeeCache();
  });
};

export const deleteEmployeeWorkAssignment = (assignmentId, params = {}) => {
  return apiClient.delete(
    `/employees/api/employee-work-assignments/${assignmentId}/`,
    { params }
  ).finally(() => {
    clearEmployeeCache();
  });
};


/* =====================================================
   ASSIGNED PRODUCTIVITY (NEW)
   ===================================================== */
export const getAssignedProductivity = (params = {}) =>
  dedupGet(`assigned_prod_${JSON.stringify(params)}`, () =>
    apiClient.get("/employees/api/assigned-productivity/", { params })
  );

export const createAssignedProductivity = (data) => {
  return apiClient.post("/employees/api/assigned-productivity/", data).finally(() => {
    clearEmployeeCache();
  });
};


/* =====================================================
   TEAM TIMESHEET  (Manager → view team's weekly work assignments)
   GET /employees/api/team-timesheet/?week_start=YYYY-MM-DD
   Returns: { week_start, week_end, employees: [...] }
   Each employee: { employee_id, full_name, role, assignments, total_hours }
   Each assignment: { id, activity_date, project_name, discipline_name, drawing_type, description, duration_hours }
===================================================== */
export const getTeamTimesheet = (params = {}) =>
  dedupGet(`team_timesheet_${JSON.stringify(params)}`, () =>
    apiClient.get("/employees/api/team-timesheet/", { params })
  );
